<template>
  <div class="com">
    <div class="col">
      <div class="col-item">
        <div class="title">
          KIT ID:
        </div>
        <div class="info">
          <span class="info-item kit-id">{{
            convertKitId(kitV2Details.kit_id)
          }}</span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Your Profile:
        </div>
        <div class="info">
          <span class="info-item">
            {{ userInfo.first_name + " " + userInfo.last_name }}
          </span>
          <span class="info-item">{{ contacts.mail }}</span>
          <span class="info-item">{{ makePhone(contacts.phone) }}</span>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="col-item">
        <div class="title">
          Samples Collected by:
        </div>
        <div class="info">
          <span class="info-item">
            {{
              kitV2Details.collected_first_name + " " + kitV2Details.collected_last_name
            }}
          </span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Sampling Date:
        </div>
        <div class="info">
          <span class="info-item">{{ date(kitV2Details.sampling_date) }}</span>
        </div>
      </div>
      <div class="col-item">
        <div class="title">
          Sampling Location:
        </div>
        <div class="info">
          <span class="info-item">
            {{
              kitV2Details.address +
                ", " +
                kitV2Details.city +
                ", " +
                kitV2Details.state +
                ", " +
                kitV2Details.zip
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";

export default {
  name: "FinalInfo",
  mixins: [parseAndConvertKitId],
  computed: {
    ...mapGetters(["userInfo", "contacts", "kitV2Details"])
  },
  methods: {
    date(localDate) {
      if (!localDate) return "00/00/0000";
      const formatted = moment(localDate).format("MMMM D, YYYY");
      return formatted === "Invalid date" ? "00/00/0000" : formatted;
    },
    makePhone(phone) {
      if (phone) {
        if (phone === null || phone === undefined) {
          return null;
        }
        const cleanPhone = phone.replace(/\D/g, '');
        if (cleanPhone.length === 11 || cleanPhone.length === 10) {
          const phoneArr = cleanPhone.split("");
          let convertedPhone = null;
          if (cleanPhone.length === 11) {
            convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
          } else if (cleanPhone.length === 10) {
            convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
          }
          return convertedPhone;
        } else {
          return null;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.com {
  padding: 36px 10px 5px 10px;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
}
.col {
  width: 100%;
  max-width: 190px;
  display: flex;
  align-self: center;
  flex-direction: column;
}
.col-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 16px;
  line-height: 20px;
}
.info {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.title {
  color: $gray;
  font-size: 16px;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.info-item {
  color: $gray;
  font-size: 16px;
  text-align: center;
  font-family: TTNormsRegular, sans-serif;
  display: block;
  line-height: 1.4;
  &.kit-id {
    text-transform: uppercase;
  }
}
@media (max-width: 568px) {
  .com {
    flex-direction: column;
    align-items: center;
  }
  .info-item {
    max-width: 100%;
  }
}
</style>
